import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/allied.png'
import _imports_1 from '@/assets/axis.png'


const _hoisted_1 = { class: "bg-neutral-900 rounded-lg mb-4" }
const _hoisted_2 = { class: "flex p-4 flex-col w-full" }
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = { class: "p-2 flex gap-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-[16px] h-[16px] grow-0 relative top-1"
}, null, -1)
const _hoisted_6 = { class: "text-center p-2" }
const _hoisted_7 = { class: "p-2 flex gap-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-[16px] h-[16px] grow-0 relative top-1"
}, null, -1)
const _hoisted_9 = { class: "border-4 border-neutral-900" }
const _hoisted_10 = { class: "w-full bg-red-500 h-5" }


export default /*#__PURE__*/_defineComponent({
  __name: 'amountDivider',
  props: ['label', 'valueA', 'valueB', 'displayA', 'displayB'],
  setup(__props) {

const props = __props;

// eslint-disable-next-line


const getPercentage = () : string => {
	return ((Number(props.valueA + 1) / (Number(props.valueA + 1)+Number(props.valueB + 1))) * 100).toFixed(0);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", null, _toDisplayString(props.displayA? props.displayA : props.valueA), 1)
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(props.label), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, _toDisplayString(props.displayB? props.displayB : props.valueB), 1),
          _hoisted_8
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "bg-cyan-600 h-5",
            style: _normalizeStyle(`width: ${getPercentage()}%`)
          }, null, 4)
        ])
      ])
    ])
  ]))
}
}

})